export default __webpack_public_path__ + "static/media/TOEFLS.95d0a0e2.png";